import React, { useState } from "react";
import { GrClose } from "react-icons/gr";
import PropTypes from "prop-types";
import Services from "../../pages/reporting/partial/Services";
import UpdateUpselling from "./updateUpselling";
import useModal from "../../hooks/useModal";
import { useStateValue } from "../../states/StateProvider";

const DienstleistungenModal = ({
                                   data,
                                   handleClick,
                                   setEditStates,
                                   upsellingOptions,
                                   firma,
                                   onClose,
                               }) => {
    const { toggleUpsellingModal } = useModal();
    const [{ upsellingModal }] = useStateValue();
    const [editInfo, setEditInfo] = useState("");
    const [editInfoFull, setEditInfoFull] = useState("");
    const [editID, setEditID] = useState(1);

    const handleEditStates = (u, index) => {
        const first = u[1].split(",")[0];
        if (first !== "Vertrag aktiv" && first !== "Vertrag inaktiv") {
            setEditInfo(first);
            setEditInfoFull(u);
            setEditID(index + 1);
            toggleUpsellingModal();
        }
    };

    return (
        <>
            {/* Backdrop with blur; click to close */}
            <div
                className="fixed inset-0 z-40 bg-black/50 "
                style={{ backgroundColor: "rgba(7, 7, 7, 0.5)" }}
                onClick={onClose}
            />

            {/* Modal layer */}
            <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
                {/* Card (no overflow clipping; inner container scrolls) */}
                <div
                    className={`relative mx-auto rounded-2xl bg-white p-6 shadow-2xl ${
                        upsellingModal ? "w-full max-w-2xl" : "w-fit min-w-[600px] max-w-[95vw]"
                    }`}
                    onClick={(e) => e.stopPropagation()}
                >
                    {/* Close icon */}
                    <button
                        type="button"
                        aria-label="Schließen"
                        className="absolute right-4 top-4 text-gray-700 hover:text-gray-900"
                        onClick={onClose}
                    >
                        <GrClose size={22} />
                    </button>

                    {/* Scrollable content wrapper (keeps dropdowns free to overflow outside) */}
                    <div className="max-h-[80vh] overflow-y-auto">
                        {!upsellingModal ? (
                            <>
                                <div className="w-full overflow-x-auto">
                                    {data && Object.keys(data).length > 0 ? (
                                        <Services
                                            data={data}
                                            handleClick={handleClick}
                                            setEditStates={handleEditStates}
                                            FPID={firma}
                                        />
                                    ) : (
                                        <div className="py-4 text-center text-gray-500">
                                            Keine Dienstleistungsdaten verfügbar
                                        </div>
                                    )}
                                </div>
                            </>
                        ) : (
                            <div className="w-full">
                                <UpdateUpselling
                                    FPID={firma}
                                    editID={editID}
                                    options={upsellingOptions}
                                    dataFull={editInfoFull}
                                    data={editInfo}
                                    toggle={toggleUpsellingModal}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

DienstleistungenModal.propTypes = {
    data: PropTypes.object.isRequired,
    handleClick: PropTypes.func.isRequired,
    setEditStates: PropTypes.func.isRequired,
    upsellingOptions: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
    firma: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    onClose: PropTypes.func.isRequired,
};

export default DienstleistungenModal;
